/**
 * Cabecera de sección/página de la librería de UI (Tailwind, estilos del
 * proyecto).
 *
 * Presentacional y sin lógica: bloque "eyebrow + título + lead" que abre una
 * sección. Estética del proyecto (paridad con el SSR): eyebrow azul opcional,
 * título en peso fuerte y color oscuro, y un lead opcional en gris. El nivel
 * semántico del título se controla con `as` (default `h2`) para encajar en la
 * jerarquía de la página.
 */
import { type ElementType } from "react";

import { cn } from "./cn";

export interface SectionHeadingProps {
  /** Etiqueta superior breve (azul). */
  eyebrow?: string;
  /** Título de la sección (obligatorio). */
  title: string;
  /** Párrafo introductorio opcional. */
  lead?: string;
  /** Nivel semántico del título (default `h2`). */
  as?: ElementType;
  className?: string;
}

export function SectionHeading({
  eyebrow,
  title,
  lead,
  as,
  className,
}: SectionHeadingProps) {
  const Heading = as ?? "h2";
  return (
    <div className={cn(className)}>
      {eyebrow ? (
        <span className="text-xs font-semibold uppercase tracking-wide text-brand">
          {eyebrow}
        </span>
      ) : null}
      <Heading className="mt-1 text-2xl font-bold tracking-tight text-slate-900">
        {title}
      </Heading>
      {lead ? <p className="mt-2 text-slate-500">{lead}</p> : null}
    </div>
  );
}
